export const messages = {
  en: {
    changeLocale: '中文',
    switch: 'Switch',
    name: 'Distributor Platform',
    router: {
      schoolMgmt: 'School Management',
      viewSchool: 'View School',
      addSchool: 'Add School',
      editSchool: 'Edit School',
      staffMgmt: 'Staff Management',
      personal: 'Personal',
    },
    login: {
      accountLogin: 'Account Login',
      emailTitle: 'Contact email',
      enterAccount: 'Please enter account!',
      enterAccountPlaceholder: 'Please enter account',
      enterPassword: 'Please enter password!',
      enterPasswordPlaceholder: 'Enter password',
      login: 'Login',
      loginAuto: 'Automatic login within 7 days',
      systemName: 'Skill Assessment and Teaching Management System',
      forgetPassword: 'Forget Password?',
      resetSuccessTip:
        'A password reset verification has been sent to your email address {email}. Please login with the modified password.',
      retrievePassword: 'Retrieve Password',
      next: 'Next',
      backToLogin: 'Back to login',
      setNewPassword: 'Set new password',
      enterNewPassword: 'Please enter new password',
      enterNewPasswordAgain: 'Please enter again',
      passwordNotEqual: 'The two passwords you typed do not match',
      resetPasswordSuccess: 'Modify Password Successfully',
      backAfterSeconds:
        'Back to login after {second} second | Back to login after {second} seconds',
      goToLogin: 'Go to login ({second})',
    },
    common: {
      add: 'Add',
      attention: 'Attention',
      cancel: 'Cancel',
      complete: 'Complete',
      confirm: 'Confirm',
      delete: 'Delete',
      edit: 'Edit',
      freeze: 'Freeze',
      enable: 'Enable',
      save: 'Save',
      resetPassword: 'Reset Password',
      deleteSuccess: 'Delete successfully',
      editSuccess: 'Edit successfully',
      freezeSuccess: 'Freeze successfully',
      enableSuccess: 'Enable successfully',
      saveSuccess: 'Save successfully',
      resetSuccess: 'Reset successfully',
      name: 'Name',
      operations: 'Operations',
      reset: 'Reset',
      quit: 'Quit',
      next: 'Next',
      back: 'Back',
      reserveEdit: 'Edit will not be retained after exit. Confirm to exit?',
      resetPasswordConfirm:
        'This member can use the default password to login after reset, are you sure to reset?',
      expand: 'Expand',
      collapse: 'Collapse',
    },
    schoolMgmt: {
      enterSchoolName: 'Enter school name',
      enterAbbreviation: 'Enter school short name',
      enterAddress: 'Enter address',
      enterContact: 'Enter phone number',
      enterBrief: 'Enter school brief',
      selectNature: 'Select nature',
      selectSection: 'Select section',
      enterAdminAccount: "Enter administrator's account",
      enterCorrectEmail: 'Please enter correct email',
      enterAdminName: "Enter administrator's Chinese name",
      enterAdminEnName: "Enter administrator's English name",
      emptyName: 'You must fill either Chinese name or English name',
      selectOpenSchoolYear: 'Select Open School Year',
      schoolCode: 'School Code',
      schoolName: 'School Name',
      abbreviation: 'Abbreviation',
      address: 'Address',
      contact: 'Contact',
      brief: 'Brief',
      nature: 'Nature',
      adminAccount: 'School Admin Account',
      adminName: 'Admin Chinese Name',
      adminEnName: 'Admin English Name',
      openSchoolYear: 'Open School Year',
      nameLimit: 'School name should be within 100 characters in length',
      shortNameLimit: 'Abbreviation should be within 10 characters in length',
      addressLimit: 'Address should be with in 100 characters in length',
      status: 'Status',
      teacherNum: 'Teachers',
      studentNum: 'Students',
      freezeConfirm: "After frozen, this school can't login anymore. Are you sure to freeze it?",
      enableConfirm: 'After enabled, this school will be able to login. Are you sure to enable it?',
      deleteConfirm: "After deletion, this school can't be restore. Are you sure to delete it?",
      section: 'Section',
      schoolAdmin: 'School Admin',
      ownedDistributor: 'Owned Distributor',
      featureInfo: 'Feature Info',
      featureSetting: 'Feature Setting',
      assessmentFramework: 'Assessment Framework',
      classNum: 'Classes',
      parentNum: 'Parents',
      basicInfo: 'Basic Info',
      schoolInfo: 'School Info',
      mibp: 'MIBP',
      bookSeries: 'Book Series',
      subscribedNum: 'Subscribed Number',
      schoolTotal: 'A total of 0 schools | A total of 1 school | A total of {total} schools',
      noAssessTip:
        'There is no need to set up assement framework without providing the assessment feature to this school',
      selectFrame: 'Select assessment frame',
      addSchoolSuccess: 'Add new school successfully',
      schoolNameLimit: 'School name cannot exceed 100 characters',
      schoolAbbreviationLimit: 'School abbreviation cannot exceed 50 characters',
      schoolAddressLimit: 'School address cannot exceed 500 characters',
      schoolContactLimit: 'School contact cannot exceed 100 characters',
      schoolIntroductionLimit: 'School introduction cannot exceed 500 characters',
      changeFrameTip:
        'The school will not be able to use the current framework after the framework is switched. The assessment sheet and assessment report under the current framework will be cleared.',
      moments: 'Moments',
      sharedMoments: 'Moments Shared',
      momentsWithSkills: 'Moments with Skills',
      likes: 'Likes',
    },
    schoolStatus: {
      NORMAL: 'Enabled',
      FROZEN: 'Frozen',
    },
    staffMgmt: {
      role: 'Role',
      rolePlaceholder: 'Please select role',
      staffTotal: 'A total of 0 staffs | A total of 1 staff | A total of {total} staffs',
      roleType: {
        '1404': 'Administrator',
        '1405': 'Staff',
      },
      addStaff: 'Add staff',
      editStaff: 'Edit staff',
      loginEmail: 'Login Email',
      enterLoginEmail: 'Enter login email',
      enterCorrectEmail: 'Please enter correct E-mail',
      deleteConfirm: 'Confirm deleting all records related to this staff?',
      addSuccess: 'Add successfully',
      editSuccess: 'Edit successfully',
      confirmResetPassword:
        'The staff can use the default password to login after reset, are you sure to reset?',
      account: 'Account',
      password: 'Password',
      emptyName: 'You must fill either Chinese name or English name',
      zhName: 'Chinese Name',
      enName: 'English Name',
      zhNameInvalid: 'Your Chinese name should be within 50 characters in length',
      enNameInvalid: 'Your English name should be within 50 characters in length',
      enterZhName: 'Enter Chinese name',
      enterEnName: 'Enter English name',
      admin: 'Administrators',
      staff: 'Staff',
      enterName: 'Please enter name',
      selectRole: 'Please select role',
    },
    personal: {
      personalInfo: 'Personal Information',
      accountSetting: 'Account Setting',
      avatar: 'Avatar',
      modifyAvatar: 'Modify avatar',
      zhName: 'Chinese name',
      enName: 'English name',
      zhNamePlaceholder: 'Please enter Chinese name (1-50 characters)',
      enNamePlaceholder: 'Please enter English name (1-50 characters)',
      email: 'E-mail',
      emailPlaceholder: 'Please enter E-mail',
      enterEmail: 'Please enter email',
      emailLimit: 'The email length cannot exceed 100 characters',
      enterCorrectEmail: 'Please enter correct email',
      account: 'Account',
      password: 'Password',
      modifyPassword: 'Modify password',
      save: 'Save',
      uploadAvatar: 'Click to upload avatar',
      avatarLimit: 'Support JPG, PNG format of the picture, the size of no more than 2M',
      cropTip:
        'Zoom Mouse wheel to control image display size, drag and adjust the position of the image',
      preview: 'Preview',
      reupload: 'Reupload',
      currentPassword: 'Current password',
      currentPasswordPlaceholder: 'Please enter current password',
      newPassword: 'New password',
      newPasswordPlaceholder: 'Please enter new password',
      repeatPassword: 'Repeat password',
      repeatPasswordPlaceholder: 'Please repeat new password',
      wrongAvatar: 'Please upload avatar in correct format!',
      wrongBrowser:
        'Sorry, the current browser does not support uploading avatars, please try again with a new browser',
      modifySuccess: 'Modify successfully',
      passwordLimit: 'The password must be a combination of 8-20 characters, letters and Numbers',
      wrongPassword: 'Different passwords!',
      nameInvalid: 'Name Invalid.',
    },
    notFound: {
      notFound: 'Sorry, the page you visited does not exist.',
      backToHome: 'Back to Home',
    },
    clientFeature: {
      moment: 'Moments',
      comment: 'Comment Moment',
      parentMoment: 'Publish Moment (Parent)',
      assessment: 'Assess',
      assessmentSheet: 'Assessment Sheet',
      assessmentReport: 'Assessment Report',
      application: 'Apps',
      attendance: 'Attendance',
      dailyCare: 'Daily Cares',
      diary: 'Diaries',
      sketch: 'Sketch',
      recipe: 'Recipe',
      album: 'Class Album',
      calendar: 'School Calendar',
      leaveAudit: 'Leave Audit',
      mibp: 'MIBP',
      learningJournal: 'Learning Journal',
      phdCourse: 'PHD',
      message: 'Messages',
      replyMessage: 'Reply messages (Parent)',
      sendMessage: 'Send messages (Parent)',
    },
    statusConstant: {
      1220: 'Enabled',
      1221: 'Frozen',
      1230: 'Kindergarten',
      1231: 'Primary School',
    },
  },
  zh: {
    changeLocale: 'English',
    switch: '切换',
    name: '经销商平台',
    router: {
      schoolMgmt: '学校管理',
      viewSchool: '查看学校',
      addSchool: '新增学校',
      editSchool: '编辑学校',
      staffMgmt: '人员管理',
      personal: '个人中心',
    },
    login: {
      accountLogin: '账号密码登录',
      emailTitle: '联系邮箱',
      enterAccount: '请输入账号！',
      enterAccountPlaceholder: '请输入账号',
      enterPassword: '请输入密码！',
      enterPasswordPlaceholder: '请输入密码',
      login: '登录',
      loginAuto: '7天内自动登录',
      systemName: '素质评估与教学管理系统',
      forgetPassword: '忘记密码?',
      resetSuccessTip: '已向您的邮箱{email}发送重置密码验证，请使用修改后的密码进行登录',
      retrievePassword: '找回密码',
      next: '下一步',
      backToLogin: '返回登录页',
      setNewPassword: '设置新密码',
      enterNewPassword: '请输入新密码',
      enterNewPasswordAgain: '请再输入一遍',
      passwordNotEqual: '两次输入的密码不一致',
      resetPasswordSuccess: '修改密码成功',
      backAfterSeconds: '{second}秒后返回登录页',
      goToLogin: '去登录({second})',
    },
    common: {
      add: '新增',
      attention: '注 意',
      cancel: '取消',
      complete: '完成',
      confirm: '确定',
      delete: '删除',
      edit: '编辑',
      freeze: '冻结',
      enable: '启用',
      save: '保存',
      resetPassword: '重置密码',
      deleteSuccess: '删除成功',
      editSuccess: '编辑成功',
      freezeSuccess: '冻结成功',
      enableSuccess: '启用成功',
      saveSuccess: '保存成功',
      resetSuccess: '重置密码成功',
      name: '姓名',
      operations: '操作',
      reset: '重置',
      quit: '退出',
      next: '下一步',
      back: '返回',
      reserveEdit: '退出后不会保留编辑内容，确认退出？',
      resetPasswordConfirm: '重置后该人员可以用默认密码登录，确定重置密码？',
      expand: '展开',
      collapse: '收起',
    },
    schoolMgmt: {
      enterSchoolName: '请输入学校名称',
      enterAbbreviation: '请输入学校简称',
      enterAddress: '请输入学校地址',
      enterContact: '请输入学校电话',
      enterBrief: '请输入学校简介',
      selectNature: '请选择学校性质',
      selectSection: '请选择年级',
      enterAdminAccount: '请输入学校管理员账号',
      enterCorrectEmail: '请输入正确的邮箱',
      enterAdminName: '请输入学校管理员中文名',
      enterAdminEnName: '请输入学校管理员英文名',
      emptyName: '中文名和英文名至少填写一个',
      selectOpenSchoolYear: '请选择开启学年',
      schoolCode: '学校编号',
      schoolName: '学校名称',
      abbreviation: '学校简称',
      address: '学校地址',
      contact: '联系电话',
      brief: '简介',
      nature: '学校性质',
      adminAccount: '学校管理员账号',
      adminName: '管理员中文名',
      adminEnName: '管理员英文名',
      openSchoolYear: '开启学年',
      nameLimit: '学校名称限制1-100字符',
      shortNameLimit: '学校简称限制1-10字符',
      addressLimit: '学校地址限制1-100字符',
      status: '状态',
      teacherNum: '教师数量',
      studentNum: '学生数量',
      freezeConfirm: '冻结学校后学校不可登录，确认冻结学校？',
      enableConfirm: '启用学校后学校将可以登录，确认启用学校？',
      deleteConfirm: '删除后该学校将无法启用，确认删除学校？',
      section: '年级',
      schoolAdmin: '学校管理员',
      ownedDistributor: '所属经销商',
      featureInfo: '功能信息',
      featureSetting: '功能设置',
      assessmentFramework: '评估框架',
      classNum: '班级数量',
      parentNum: '家长数量',
      basicInfo: '基本信息',
      schoolInfo: '学校信息',
      mibp: '多元智能双语课程',
      bookSeries: '绘本系列',
      subscribedNum: '订阅人数',
      schoolTotal: '共{total}所学校',
      noAssessTip: '未给学校开通评估功能，无需设置评估框架',
      selectFrame: '请选择评估框架',
      addSchoolSuccess: '学校新增成功',
      schoolNameLimit: '学校名称不能超过100字',
      schoolAbbreviationLimit: '学校简称不能超过50字',
      schoolAddressLimit: '学校地址不能超过500字',
      schoolContactLimit: '学校联系电话不能超过100字',
      schoolIntroductionLimit: '学校简介不能超过500字',
      changeFrameTip:
        '切换框架后学校将无法使用当前框架，当前框架下的评估表和评估报告将清除，确认切换评估框架？',
      moments: '成长记录',
      sharedMoments: '已分享的成长记录',
      momentsWithSkills: '与技能相关的成长记录',
      likes: '点赞数',
    },
    schoolStatus: {
      NORMAL: '启用',
      FROZEN: '冻结',
    },
    staffMgmt: {
      role: '角色',
      rolePlaceholder: '请选择角色',
      staffTotal: '共{total}位人员',
      roleType: {
        '1404': '管理员',
        '1405': '员工',
      },
      addStaff: '新增人员',
      editStaff: '编辑人员',
      loginEmail: '登录邮箱',
      enterLoginEmail: '请输入登录邮箱',
      enterCorrectEmail: '请输入正确的邮箱',
      deleteConfirm: '确定彻底删除该人员及其所有记录？',
      addSuccess: '新增成功',
      editSuccess: '编辑成功',
      confirmResetPassword: '重置后该人员可以用默认密码登录，确定重置密码？',
      account: '账号',
      password: '密码',
      emptyName: '中文名和英文名至少填写一个',
      zhName: '中文名',
      enName: '英文名',
      zhNameInvalid: '中文名长度应为1-50字符',
      enNameInvalid: '英文名长度应为1-50字符',
      enterZhName: '请输入中文名',
      enterEnName: '请输入英文名',
      admin: '管理员',
      staff: '员工',
      enterName: '请输入姓名',
      selectRole: '请选择角色',
    },
    personal: {
      personalInfo: '个人信息',
      accountSetting: '账户设置',
      avatar: '头像',
      modifyAvatar: '更换头像',
      zhName: '中文名',
      enName: '英文名',
      zhNamePlaceholder: '请输入中文名(1-50字符)',
      enNamePlaceholder: '请输入英文名(1-50字符)',
      email: '邮箱',
      emailPlaceholder: '请输入邮箱',
      enterEmail: '请输入邮箱',
      emailLimit: '邮箱长度不能超过100字符',
      enterCorrectEmail: '请输入正确的邮箱',
      account: '帐户',
      password: '密码',
      modifyPassword: '修改密码',
      save: '保存',
      uploadAvatar: '点击上传头像',
      avatarLimit: '支持jpg、png格式的图片，大小不超过2M',
      cropTip: '鼠标滚轮缩放控制图片显示大小，拖拽调整图片位置',
      preview: '预览',
      reupload: '重新上传',
      currentPassword: '当前密码',
      currentPasswordPlaceholder: '请输入当前密码',
      newPassword: '新密码',
      newPasswordPlaceholder: '请输入新密码',
      repeatPassword: '确认密码',
      repeatPasswordPlaceholder: '请确认密码',
      wrongAvatar: '请上传正确的头像！',
      wrongBrowser: '抱歉，当前浏览器暂不支持上传头像，请更换浏览器重试',
      modifySuccess: '修改成功',
      passwordLimit: '密码必须为8-20位，字母+数字的组合',
      wrongPassword: '两次输入的密码不一致！',
      nameInvalid: '中文名或英文名有误！',
    },
    notFound: {
      notFound: '抱歉，您访问的页面不存在。',
      backToHome: '返回首页',
    },
    clientFeature: {
      moment: '成长记录',
      comment: '评论成长记录',
      parentMoment: '发布成长记录（家长端）',
      assessment: '评估',
      assessmentSheet: '评估表',
      assessmentReport: '评估报告',
      application: '应用',
      attendance: '考勤',
      dailyCare: '生活记录',
      sketch: '画板',
      recipe: '食谱',
      diary: '日记簿',
      album: '班级相册',
      calendar: '校历',
      leaveAudit: '请假审批',
      mibp: '多元智能双语课程',
      learningJournal: '学习日志',
      phdCourse: 'PHD',
      message: '消息通知',
      sendMessage: '发消息（家长端）',
      replyMessage: '回复消息（家长端）',
    },
    statusConstant: {
      1220: '启用',
      1221: '冻结',
      1230: '幼儿园',
      1231: '小学',
    },
  },
}

export const dateTimeFormats = {
  en: {
    month: {
      year: 'numeric',
      month: 'short',
    },
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    },
  },
  zh: {
    month: {
      year: 'numeric',
      month: 'short',
    },
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    },
  },
}
